import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 53 — GoHighLevel white-label & vertical hiring cluster service links.
 *
 * Every Batch 53 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch53Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH53_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-white-label-fulfillment-cost": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /white-label template that deploys a snapshot is not a white-label system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-snapshot-build-vs-template": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /template every competitor buys is not a build that differentiates/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-migration-specialist-cost": {
    url: "/gohighlevel-revops-architect",
    anchor: /GoHighLevel account full of contacts and empty of automations/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "hire-gohighlevel-real-estate-specialist": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /GoHighLevel generalist who builds workflows is not a real estate specialist/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
